import {SmartComponent} from "smart-component-js";
import Cookies from "js-cookie";

class HeaderMdComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.logout = this.element.querySelectorAll('.headerMD__user-menu-link.logout');

        this.init();
    }


    toggleHeaderUserLinks() {
        this.userCta = this.element.querySelector('.headerMD__user-logged');
        this.userMenu = this.element.querySelectorAll('.headerMD__user-menu-wrapper');

        if (this.userCta) {
            this.userCta.addEventListener('click', () => {
                this.userMenu.forEach((el) => {
                    el.classList.toggle('open')
                })
            })

        }
    }

    toggleMenuLink() {
        this.hamburger = this.element.querySelector('.headerMD__hamburger');
        this.menuMobile = this.element.querySelector('.headerMD__menu-mobile-wrapper');
        if (this.hamburger) {
            this.hamburger.addEventListener('click', () => {
                this.menuMobile.classList.toggle('open');
            })
        }
    }


    init() {
        this.toggleHeaderUserLinks();
        this.toggleMenuLink();

        this.logout?.forEach((el) => el.addEventListener('click', () => {
            Cookies.remove('yxp_regulation_modal_visibility');
            this.element.classList.add('loading');
            window.authProvider.auth.doLogout();
        }));
    }


}

export default HeaderMdComponent;
